import script from "./MapLocus.vue?vue&type=script&lang=ts&setup=true"
export * from "./MapLocus.vue?vue&type=script&lang=ts&setup=true"

import "./MapLocus.vue?vue&type=style&index=0&id=c71f2042&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c71f2042"]])

export default __exports__